import styled, { css } from "styled-components";
export const WidgetWrapper = styled.div`
    ${props =>{
    if(!props.noBorder) {
        return css`
        border: solid 1px #ebeef7;
        border-radius: 5px;
        `;
    }
    }}    
    margin: 8px 8px;
    padding:10px;
    background: white;
    border: solid 2px #cfd0d5;
    border-radius: 5px;
`;

export const InlineWidgetWrapper = WidgetWrapper.extend`
    flex-direction: row;
    display: flex;
    flex: none;
    justify-content: space-between;
    padding:10px;
    background: white;
    border: solid 2px #cfd0d5;
    border-radius: 5px;
`

export const WidgetMember = styled.div`
     min-width: 42%;
`

export const WidgetMember2 = styled.div`
     min-width: 58%;
`

export const WidgetMember3 = styled.div`
     min-width: 50%;
`


// WEBPACK FOOTER //
// ./src/module-analytics/components/Widget.js